import { render } from "./Components.vue?vue&type=template&id=5617ce98&scoped=true"
import script from "./Components.vue?vue&type=script&lang=js"
export * from "./Components.vue?vue&type=script&lang=js"

import "./Components.vue?vue&type=style&index=0&id=5617ce98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5617ce98"],['__file',"src/views/Demo/Components.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5617ce98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5617ce98', __exports__)) {
    api.reload('5617ce98', __exports__)
  }
  
  module.hot.accept("./Components.vue?vue&type=template&id=5617ce98&scoped=true", () => {
    api.rerender('5617ce98', render)
  })

}


export default __exports__